<template>
  <b-container class="contact-profile">
    <b-row>
      <b-col md="12">
        <router-link
          :to="backPage"
          tag="div"
          class="back-to-list">
          <icon
            name="angle-left"
            width="14"
            height="14"/> Back to {{ backPage.name }}
        </router-link>
      </b-col>
      <b-col md="4">
        <div class="box-info user-profile-data">
          <div
            v-if="loadingContact"
            class="loader loader-main">
            <div class="loading-circle"/>
          </div>
          <ContactInfo
            v-show="!loadingContact"
            :contact="contact"/>
        </div>
      </b-col>
      <b-col md="8">
        <h3>Activity</h3>
        <div class="activities">
          <div
            v-if="!loadingActivities && !activities.length"
            class="box-info no-activity">
            <h3>No activities for this contact.</h3>
          </div>
          <div
            v-for="(activity, index) in activities"
            v-else
            :key="index"
            class="box-info">
            <span
              :style="{'background-color': activityIcon(activity).color}"
              class="activity-icon">
              <icon
                :name="activityIcon(activity).icon"
                :style="{
                  // width: activityIcon(activity).size,
                  // height: activityIcon(activity).size,
                  // 'margin-left': activityIcon(activity).margin,
                }"
              />
            </span>
            <span class="happened-at">{{ activity.happened_at | dateText }}</span>
            <p class="">{{ activityText(activity) }}</p>
          </div>
          <span id="page-tracker"/>
          <div
            v-if="loadingActivities"
            class="loader">
            <div class="loading-circle"/>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import '@/assets/css/modules/_contact-profile.scss';

import { mapGetters, mapActions } from 'vuex';
import ContactInfo from './ContactInfo';

export default {
  name: 'Profile',
  components: {
    ContactInfo,
  },
  data() {
    return {
      activities: {},
      page: 1,
      lastPage: false,
      limit: 10,
      platforms: {
        whatsapp: 'WhatsApp',
        messenger: 'Messenger',
      },
    };
  },
  computed: {
    ...mapGetters({
      contact: 'contact/contact',
      loadingContact: 'contact/loadingContact',
      activityList: 'contact/activityList',
      loadingActivities: 'contact/loadingActivities',
      apiError: 'contact/apiError',
    }),
    backPage() {
      return (this.$route.name === 'ContactProfile') ? { name: 'Contacts' } : { name: 'Subscribers' };
    },
  },
  watch: {
    loadingActivities(loading) {
      if (!loading) {
        if (this.page === 1) {
          this.activities = this.activityList.data;
        } else {
          this.activities = this.$lodash.concat(this.activities, this.activityList.data);
        }
        this.lastPage = this.activityList.meta.last_page;
        this.$nextTick(() => {
          this.trackPageScroll();
        });
      }
    },
    apiError(error) {
      if (error.status === 422) {
        //
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    this.fetchContact({
      merchant_id: this.$route.params.merchant_id,
      contact_id: this.$route.params.contact_id,
    });
    this.loadActivities();
    this.trackPageScroll();
    window.onscroll = (() => {
      this.trackPageScroll();
    });
  },
  beforeDestroy() {
    window.onscroll = null;
  },
  methods: {
    ...mapActions({
      fetchContact: 'contact/fetchContact',
      fetchActivities: 'contact/fetchActivities',
    }),
    trackPageScroll() {
      const trackerPosition = window.$('#page-tracker').offset().top - window.$(window).height();
      const windowScroll = window.$(window).scrollTop();
      if (windowScroll >= trackerPosition) {
        this.loadMoreActivities();
      }
    },
    loadMoreActivities() {
      if (!this.loadingActivities && (this.page < this.lastPage)) {
        this.page += 1;
        this.loadActivities();
      }
    },
    loadActivities() {
      this.fetchActivities({
        merchant_id: this.$route.params.merchant_id,
        contact_id: this.$route.params.contact_id,
        data: {
          limit: this.limit,
          page: this.page,
        },
      });
    },
    activityIcon(activity) {
      const platform = activity.meta_data ? activity.meta_data.platform : null;
      const platformIcon = (platform === 'whatsapp') ? 'brands/whatsapp' :
        ((platform === 'messenger') ? 'brands/facebook-messenger' : 'comment');

      const activityIcons = {
        contact_created: {
          icon: 'user',
          color: '#b1b8c4',
          size: '13px',
          margin: '0',
        },
        conversation_started: {
          icon: platformIcon,
          color: '#00bfa5',
          size: '14px',
          margin: '0',
        },
        contact_subscribed: {
          icon: 'list-alt',
          color: '#3d8bfc',
          size: '14px',
          margin: '0',
        },
        contact_unsubscribed: {
          icon: 'comment-slash',
          color: '#ed7474',
          size: '14px',
          margin: '0',
        },
        daily_contacted: {
          icon: platformIcon,
          color: '#00bfa5',
          size: '14px',
          margin: '0',
        },
        invoice_sent: {
          icon: 'paper-plane',
          color: '#3d8bfc',
          size: '13px',
          margin: '-2px',
        },
        invoice_paid: {
          icon: 'dollar-sign',
          color: '#00bfa5',
          size: '14px',
          margin: '0',
        },
        invoice_refunded: {
          icon: 'dollar-sign',
          color: '#ed7474',
          size: '14px',
          margin: '0',
        },
        invoice_fulfilled: {
          icon: 'check-circle',
          color: '#3d8bfc',
          size: '14px',
          margin: '0',
        },
        receipt_sent: {
          icon: 'file-pdf',
          color: '#3d8bfc',
          size: '13px',
          margin: '2px',
        },
        contact_deleted: {
          icon: 'trash-alt',
          color: '#ea2d2d',
          size: '14px',
          margin: '0',
        },
        default: {
          icon: 'circle',
          color: '#b1b8c4',
          size: '14px',
          margin: '0',
        },
      };

      return (activity.type in activityIcons) ? activityIcons[activity.type] : activityIcons.default;
    },
    activityText(activity) {
      switch (activity.type) {
        case 'contact_created': {
          return 'Contact created.';
        }
        case 'conversation_started': {
          const platform = this.platforms[activity.meta_data.platform];
          return `Contact started ${platform} conversation.`;
        }
        case 'daily_contacted': {
          const platform = this.platforms[activity.meta_data.platform];
          return `Contact sent first message in ${platform} conversation in a day.`;
        }
        case 'contact_subscribed': {
          const listName = activity.optin_source.name.replace(/\b\w/g, l => l.toUpperCase());
          return activity.user ?
            `Contact has been subscribed using "${listName}" opt-in source by ${activity.user.name}` :
            `Contact subscribed using "${listName}" opt-in source.`;
        }
        case 'contact_unsubscribed': {
          return 'Contact unsubscribed from receiving notifications.';
        }
        default:
          return activity.description;
      }
      // invoice_sent
      // invoice_paid
      // invoice_refunded
      // invoice_fulfilled
      // receipt_sent
    },
  },
};
</script>
